import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AdminComponent]
})
export class AdminModule { }



// WEBPACK FOOTER //
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/admin/admin.module.ts